export default __webpack_public_path__ + "static/media/bgHead1.5724a5ad.png";